export default {
  taskListTemplate: {
    include_task_list_template_sections: true,
  },
}
